var option_default = {
  "option": "vUknQ",
  "user_choice": "bR4JS",
  "check": "HvIid",
  "image": "EBPbf",
  "input": "JIoEt",
  "title": "_3D7yA",
  "centered": "JvB6R",
  "with_result": "rktCI",
  "list": "I84TA",
  "with_image": "fvcP-",
  "progress": "hfJQJ",
  "progress_value": "_2mZei",
  "label": "TE-P6",
  "cta": "jXj5x",
  "adornment_icon": "HZ-H3",
  "remove": "sL4fe",
  "removeButton": "gQTuQ",
  "removeButtonIcon": "KL8i7",
  "overlay": "-nZ0B",
  "shown": "BT1O3",
  "dark": "-SMjm",
  "spinner": "BJCGd",
  "spin": "bQHtz"
};
export {
  option_default as default
};
//# sourceMappingURL=option-scss.js.map
